import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ColorIndicator from 'further-ui/components/ColorIndicator';
import { Row } from 'further-ui/components/Layout';
import React from 'react';

const PaddedBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.xs),
}));

type Props = {
  listIndex?: number;
  text: string;
};

const ColorIndicatorWithText: React.FC<Props> = ({ listIndex, text }) => {
  return (
    <Row centered spacing="xs">
      <PaddedBox>
        <ColorIndicator listIndex={listIndex} />
      </PaddedBox>
      <Typography variant="inherit">{text}</Typography>
    </Row>
  );
};

export default ColorIndicatorWithText;
